import {
  ConfigDomain,
  ConfigOptions,
  ConfigType,
  ConfigTypes,
} from '../config.types';

export class Config {
  code?: number;
  createdAt?: string;
  updatedAt?: string;

  name: string;
  description: string;
  type: ConfigTypes;
  domain: ConfigDomain;

  trueValue: boolean | number | string;
  trueType: ConfigTypes;

  readonly = false;

  options: ConfigOptions = {};

  constructor(data: ConfigType) {
    this.name = data.name;
    this.description = data.description;
    this.type = data.type;
    this.trueType = data.type;
    this.domain = data.domain;
    this.readonly = data.readonly || false;
    this.options = data.options || {};

    if (data.type === 'BOOLEAN') this.trueValue = false;
    else if (data.type === 'NUMBER') this.trueValue = 0;
    else this.trueValue = '';
  }

  get booleanValue(): boolean {
    if (this.trueValue === true || this.trueValue === 1) return true;
    if (this.trueValue === false || this.trueValue === 0) return false;
    if (typeof this.trueValue === 'string') {
      return this.trueValue === 'true' || this.trueValue === '1';
    }
    return false;
  }

  set booleanValue(value: boolean) {
    if (this.trueType === 'BOOLEAN') this.trueValue = value ? true : false;
    else if (this.trueType === 'NUMBER') this.trueValue = value ? 1 : 0;
  }

  getTrueTypeOf(bool: boolean) {
    if (this.type === 'BOOLEAN') return bool ? true : false;
    return bool ? 1 : 0;
  }
  getOptionLabel(optionValue: number): string {
    return (
      Object.values(this.options).find((option) => option.value == optionValue)
        ?.label || ''
    );
  }
}
